const OpenAI = require('openai');

const OPENAI_API_KEY = "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";

// Initialize OpenAI
export const openai = new OpenAI({ apiKey: OPENAI_API_KEY, dangerouslyAllowBrowser: true, defaultHeaders: {"OpenAI-Beta": "assistants=v2"} });
